import { urlApi } from '../configuracion/serverConfig';
import { authSesion, headers } from "../helpers/authSesion";

const getUsers = (filter) => {
    const sesionToken = authSesion();
    return fetch(`${urlApi}/usuario/nom/${sesionToken}/${filter || "*"}`, {
        method: 'GET',
        headers,
    })  
    .then(res => res.json())
    .then(data => data)
    .then(data => {
        return data.status === 0 ? data : {error: true, msg: data.objError.msgError}
    })
    .catch(err => {
        console.log("Error", err);
        return {error: true, msg: "ERROR"}
    });
}

const resendActivation = (correo) => {
    const sesion = authSesion();
    return fetch(`${urlApi}/usuario/send-active`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ sesion, correo }),
    })
    .then(res => res.json())
    .then(data => data)
    .then(data => {
        return data.status === 0 ? data : {error: true, msg: data.objError.msgError}
    })
    .catch(err => {
        console.log("Error", err);
        return {error: true, msg: "ERROR"}
    });
}

export const userServices = {
    getUsers,
    resendActivation,
}